import axios from "axios";
import router from "@/router";
import store from "@/store";
import i18n from "@/plugins/i18n.js";

window.axios = axios;

if (import.meta.env.MODE === "development") {
  axios.defaults.baseURL = "https://kolumbia.dksnap.com";
  // axios.defaults.baseURL = "https://kasaisushi.dksnap.com";
  // axios.defaults.baseURL = "https://sactunviajes.com";
}

// Request interceptor
axios.interceptors.request.use((request) => {
  const token = store.getters.token;
  if (token) {
    request.headers.common.Authorization = `Bearer ${token}`;
  }

  return request;
});

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;
    var str = "";
    var p = "";

    if (status >= 500) {
      Swal.fire({
        icon: "error",
        title: i18n.t("errors.error_alert_title"),
        text: i18n.t("errors.error_alert_text"),
        reverseButtons: true,
        confirmButtonText: "ok",
      });
    }

    /**
     * @status 401 => LOGIN BAD CREDENTIALS
     * @status 403 => PERMITIONS
     * @status 404 => SOME DATE NOT EXIST
     * @status 405 => VALIDATION ERROR
     * @status 422 => ERROR REQUEST
     * @status 429 => TOO ATTEMPS LOGIN
     *
     */
    var DefaultStatus = [400, 429, 404];

    if (DefaultStatus.includes(status)) {
      if (error.response.data.message) {
        Swal.fire({
          icon: "error",
          title: i18n.t("errors.error_alert_title"),
          text: error.response.data.message,
          reverseButtons: true,
          confirmButtonText: "ok",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: i18n.t("errors.error_alert_title"),
          // text: error.response.data.message.note,
          text: i18n.t("errors.error_alert_text"),
          reverseButtons: true,
          confirmButtonText: "ok",
        });
      }
    }

    if (status === 401) {
      Swal.fire({
        icon: "error",
        title: "Bad Login",
        text: error.response.data.message,
        reverseButtons: true,
        confirmButtonText: "ok",
      }).then(() => {
        // store.commit("auth/LOGOUT");
      });
    }

    if (status === 403) {
      router.push({ name: "Dashboard" });
      Swal.fire({
        icon: "error",
        title: i18n.t("errors.error_alert_title"),
        text: error.response.data.errors.message,
        reverseButtons: true,
        confirmButtonText: "ok",
      });
    }
    if (status === 405) {
      Swal.fire({
        icon: "error",
        title: i18n.t("errors.error_alert_title"),
        text: error.response.data.message,
        reverseButtons: true,
        confirmButtonText: "ok",
      });
    }
    //Sugetions
    if (status === 406) {
      str = "";
      for (p in error.response.data.suggestion) {
        if (
          Object.prototype.hasOwnProperty.call(
            error.response.data.suggestion,
            p
          )
        ) {
          str += error.response.data.suggestion[p] + "<br>";
        }
      }
      Swal.fire({
        icon: "info",
        title: i18n.t("errors.error_alert_title"),
        html: error.response.data.message + ":<br>" + str,
        reverseButtons: true,
        confirmButtonText: "ok",
      });
    }
    //SESIONID EXPIRED
    if (status === 410) {
      console.log("Session expired");
      store.dispatch("guest/removeSessionId");
      store.dispatch("checkout/setTotal", 0);
      setTimeout(() => {
        store.dispatch("cart/setLoad");
      }, 200);
    }

    if (status === 422) {
      str = "";
      for (p in error.response.data.errors) {
        if (
          Object.prototype.hasOwnProperty.call(error.response.data.errors, p)
        ) {
          str += p + ":" + error.response.data.errors[p] + "<br>";
        }
      }
      Swal.fire({
        icon: "error",
        title: error.response.data.message,
        html: str,
        reverseButtons: true,
        confirmButtonText: "ok",
      });
    }

    store.dispatch("loading/done");
    return Promise.reject(error);
  }
);
export default axios;
